import React from 'react';
import { ChevronLeft, Bell, UserCircle2 } from 'lucide-react';
import { theme } from '../shared/theme';
import PropertyManagementView from './PropertyManagementView';
import { useLanguage } from '../../components/LanguageContext';
import '../shared/portals.css';

// ============================================================
// Standalone preview of the owner's Property Management screen,
// styled in the managd design language. Reads the local emulator
// via the dev API — never the live backend.
// ============================================================

interface Props {
  onBack?: () => void;
  onChangeRole?: () => void;
}

const OwnerPMPreview: React.FC<Props> = ({ onBack, onChangeRole }) => {
  const { t } = useLanguage();
  const hour = new Date().getHours();
  const greeting = hour < 12 ? t('goodMorning') : hour < 18 ? t('goodAfternoon') : t('goodEvening');
  return (
  <div className="pt-screen pm-premium" style={{ background: '#f4f6f9' }}>
    {/* managd-style header */}
    <header
      style={{
        background: '#fff',
        borderBottom: `1px solid ${theme.line}`,
        padding: '12px 14px calc(12px + env(safe-area-inset-top, 0px))',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 40,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        {onBack && (
          <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, color: theme.slate, display: 'flex' }}>
            <ChevronLeft size={22} />
          </button>
        )}
        <span style={{ fontSize: 18, fontWeight: 800, color: '#12294a' }}>{t('propertyManagement')}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <Bell size={23} color="#12294a" />
        <button onClick={onChangeRole} title={t('pcChangeRole')} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', padding: 0 }}>
          <UserCircle2 size={25} color="#12294a" />
        </button>
      </div>
    </header>

    {/* Personalised greeting header */}
    <div style={{ padding: '20px 16px 6px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 13 }}>
        <div
          style={{
            width: 46, height: 46, borderRadius: 14, flexShrink: 0,
            background: 'linear-gradient(135deg, #e6cf99 0%, #d6b160 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#12294a', fontSize: 16, fontWeight: 800, letterSpacing: '0.02em',
            boxShadow: '0 4px 14px rgba(214,177,96,0.4)',
          }}
        >
          MM
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 12.5, fontWeight: 700, color: '#9a7d3c', textTransform: 'uppercase', letterSpacing: '0.07em' }}>{greeting}</div>
          <div style={{ fontSize: 20, fontWeight: 800, color: '#12294a', letterSpacing: '-0.3px' }}>Mirco Meinel</div>
        </div>
      </div>
      <p style={{ fontSize: 15, color: '#3f4a5a', marginTop: 14 }}>{t('opmTagline')}</p>
    </div>

    <PropertyManagementView currentInvestor={{ id: 'mirco-owner-001', name: 'Mirco Stefan Meinel', email: 'info@puro-properties.ae' }} />
  </div>
  );
};

export default OwnerPMPreview;
